import { COUNTRY_LIST, COUNTRY_LIST_SUCCESS, COUNTRY_LIST_FAILURE } from './actionTypes';

import { InternationalServiceState, InternationalServiceActions } from './types';

const initialState: InternationalServiceState = {
    countryList: [],
    error: null,
};

export default (state = initialState, action: InternationalServiceActions) => {
    switch (action.type) {
        case COUNTRY_LIST:
            return {
                ...state,
            };
        case COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                countryList: action.payload.countryList,
                error: null,
            };
        case COUNTRY_LIST_FAILURE:
            return {
                ...state,
                countryList: [],
                error: action.payload.error,
            };

        default:
            return {
                ...state,
            };
    }
};
